import { GuardedType, isBoolean, IsInterface } from "generic-type-guard";

import { OpenRegisterRecordPreviewPage } from "../../utilities/rpcHelper";

/**
 * Activity data attached to the {@link OpenregisterSearchModalDescriptor} activity, holding the
 * latest search result page and loading/error state. Read via
 * {@code ActivitySelectors.data(activityId)} in the modal component.
 */
export const isOpenRegisterSearchModalData = new IsInterface()
	.withProperties({
		loading: isBoolean
	})
	.withOptionalProperties({
		error: isBoolean
	})
	.get();

export type OpenRegisterSearchModalData = GuardedType<typeof isOpenRegisterSearchModalData> & {
	page?: OpenRegisterRecordPreviewPage;
};
